import request from '../request'
import type { ApiResponse } from '../types'
import type {
  agentApplyRequest,
  agentRefundRequest,
  agentInviteListItem,
  agentInviteListParams,
  agentInviteGenerateRequest,
  agentInviteGenerateResponse,
  agentInviteAcceptRequest,
  agentInviteReviewRequest,
  agentInviteRefundRequest,
  agentInviteSharesRequest,
  agentInviteShareMethodsResponse,
  agentRefundSummaryResponse,
} from './types'
export * from './types'

/**
 * 页面初始化数据
 */
export function agentPreflightApi(): Promise<ApiResponse<any>> {
  return request.get('/agent/preflight')
}

/**
 * 申请成为商家
 */
export function agentApplyApi(data: agentApplyRequest): Promise<ApiResponse<any>> {
  return request.post('/agent/apply', data)
}

/**
 * 申请退还保证金
 */
export function agentRefundApi(data: agentRefundRequest): Promise<ApiResponse<any>> {
  return request.post('/agent/refund', data)
}

/**
 * 邀请码列表（按「邀请码 + 接受会员」展示）
 * 日期筛选参数默认不传
 */
export function agentInviteListApi(
  params?: agentInviteListParams,
): Promise<ApiResponse<agentInviteListItem[]>> {
  return request.get('/agent/invite/list', { params })
}

/**
 * 生成邀请码
 * hash 需先通过支付密码校验，Scope = generate_agent_invite
 */
export function agentInviteGenerateApi(
  data: agentInviteGenerateRequest,
): Promise<ApiResponse<agentInviteGenerateResponse>> {
  return request.post('/agent/invite/generate', data)
}

/**
 * 检测邀请码是否存在
 */
export function agentInvitePreflightApi(
  data: agentInviteAcceptRequest,
): Promise<ApiResponse<null>> {
  return request.post('/agent/invite/preflight', data)
}
/**
 * 用户填写接受邀请码
 */
export function agentInviteAcceptApi(data: agentInviteAcceptRequest): Promise<ApiResponse<null>> {
  return request.post('/agent/invite/accept', data)
}

/**
 * 检查自己是否还有申请待审核
 */
export function agentApplicationPendingApi(): Promise<
  ApiResponse<{
    code: string
    /** 0=无，1=一级码商申请中，2=邀请码审核中 */
    pending_type: 0 | 1 | 2
  }>
> {
  return request.get('/agent/application/pending')
}
/**
 * 退保前检查自己的下级信息等
 */
export function agentRefundSummaryApi(): Promise<ApiResponse<agentRefundSummaryResponse>> {
  return request.get('/agent/refund/summary')
}

/**
 * 一级码商审核下级接受邀请
 */
export function agentInviteReviewApi(data: agentInviteReviewRequest): Promise<ApiResponse<null>> {
  return request.post('/agent/invite/review', data)
}

/**
 * 邀请码申请退保
 * hash 需先通过支付密码校验，Scope = refund_agent_invite
 */
export function agentInviteRefundApi(data: agentInviteRefundRequest): Promise<ApiResponse<null>> {
  return request.post('/agent/invite/refund', data)
}

/**
 * 修改邀请码「我的分成」
 */
export function agentInviteSharesApi(data: agentInviteSharesRequest): Promise<ApiResponse<null>> {
  return request.post('/agent/invite/shares', data)
}

export interface AgentDownlineDetailRequest {
  downline_id: number
  start_at?: number
  end_at?: number
}

export interface AgentDownlineDetailPaymentMethod {
  code: string
  name: string
  sell_amount: string
  sell_count: number
  commission_amount: string
}

export interface AgentDownlineDetailSummary {
  sell_amount: string
  sell_count: number
  commission_amount: string
}

export interface AgentDownlineDetailResponse {
  member_id: number
  account: string
  summary: AgentDownlineDetailSummary
  payment_methods: AgentDownlineDetailPaymentMethod[]
}

/**
 * 下级详情（金额和返佣）
 */
export function agentDownlineDetailApi(
  data: AgentDownlineDetailRequest,
): Promise<ApiResponse<AgentDownlineDetailResponse>> {
  return request.post('/agent/downline/detail', data)
}

/**
 * 可配置分成的支付方式类别（已启用）+ 预存保证金
 */
export function agentInviteShareMethodsApi(): Promise<
  ApiResponse<agentInviteShareMethodsResponse>
> {
  return request.get('/agent/invite/share-methods')
}
